export default __webpack_public_path__ + "static/media/l14.025edf78.jpg";